import script from "./TinyMCE.vue?vue&type=script&setup=true&lang=js"
export * from "./TinyMCE.vue?vue&type=script&setup=true&lang=js"

import "./TinyMCE.vue?vue&type=style&index=0&id=0c83620a&lang=scss"

const __exports__ = script;

export default __exports__